module.exports = __webpack_public_path__ + "img/p16.8d1296a6.png";